import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDashComponent } from './simple-icons-dash.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDashComponent ],
    exports:      [ SimpleIconsDashComponent ],
    bootstrap:    []
})
export class SimpleIconsDashModule {}
